import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getStylesObj } from '../../../../helpers/utils';
import MonitorContext from '../../MonitorContext';

export interface IMonitorLabelProps {
  field: string;
  style?: any;
  endWithColon?: boolean;
}

export default function MonitorLabel(props: IMonitorLabelProps) {
  const s80 = useSelector((state: any) => state.executor.s80);
  const { monitorFields } = s80;
  const context = useContext<any>(MonitorContext);

  const { field, endWithColon = true, style, ...rest } = props;
  const monitorFieldKey = `${context.monitor}_${field}`;
  if (!monitorFields[monitorFieldKey]) {
    return <div {...rest}></div>;
  }
  const { label } = monitorFields[monitorFieldKey];

  return (
    <div {...rest} style={{ ...style }}>
      {label}
      {endWithColon && ':'}
    </div>
  );
}
